import React from "react";
import {
  ImageFiftyFive,
  ImageFiftyFour,
  ImageFiftySix,
  ImageFiftyThree,
} from "../assets/images";

const BottamTab = () => {
  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.empfly.pulse",
        "_blank"
      );
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.open(
        "https://apps.apple.com/in/app/example-app/id123456789",
        "_blank"
      );
    } else {
      window.open(
        "https://play.google.com/store/apps/details?id=com.empfly.pulse",
        "_blank"
      );
    }
  };
  return (
    <div className=" bg-white">
      {/* Top Section */}
      <div className="max-w-6xl w-full mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16 mb-10">
        {/* Left Content Section */}
        <div className="flex-1 text-center lg:text-left">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            The Pulse Promise
          </h1>

          <blockquote className="text-lg sm:text-xl lg:text-2xl text-gray-700 italic leading-relaxed mb-8 font-light">
            "From diagnosis shock to long-term recovery, Empty Pulse stays
            beside you—guiding, healing, and empowering you and your loved ones
            every day."
          </blockquote>

          <p className="text-base sm:text-lg text-gray-600 mb-8 leading-relaxed">
            Your healing journey deserves empathy, guidance, and strength. Let's
            walk it together.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center lg:justify-start">
            <button className="w-full sm:w-auto bg-teal-600 hover:bg-teal-700 text-white font-semibold py-3 px-6 sm:py-4 sm:px-8 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg">
              Start Guided Recovery
            </button>
            <button
              onClick={handleDownloadClick}
              className="w-full sm:w-auto border-2 border-teal-600 text-teal-600 hover:bg-teal-50 font-semibold py-3 px-6 sm:py-4 sm:px-8 rounded-xl transition-all duration-300"
            >
              Download App
            </button>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="flex-1 flex justify-center lg:justify-end">
          <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg">
            <img
              src={ImageFiftyThree}
              alt="Two people supporting each other - healthcare illustration"
              className="w-full h-auto object-contain"
            />
            {/* Decorative background circle */}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 sm:w-80 md:w-96 h-64 sm:h-80 md:h-96 bg-gradient-to-br from-teal-100 to-blue-100 rounded-full opacity-30"></div>
          </div>
        </div>
      </div>

      <div className="bg-teal-50 py-6 px-4 rounded-xl shadow-inner">
        <div className="flex flex-wrap justify-center gap-6 sm:gap-10 md:gap-12">
          {/* Empathy */}
          <div className="flex items-center gap-3 min-w-[120px] justify-center">
            <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
              <img src={ImageFiftyFive} alt="Heart" />
            </div>
            <span className="text-gray-800 font-medium text-lg">Empathy</span>
          </div>

          <div className="flex items-center gap-3 min-w-[120px] justify-center">
            <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center">
              <img src={ImageFiftyFour} alt="Shield" />
            </div>
            <span className="text-gray-800 font-medium text-lg">Guidance</span>
          </div>

          <div className="flex items-center gap-3 min-w-[120px] justify-center">
            <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
              <img src={ImageFiftySix} alt="Shield" />
            </div>
            <span className="text-gray-800 font-medium text-lg">Strength</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottamTab;
